export { SegmentedControl } from './segmented-control';

export type {
  SegmentedControlItem,
  SegmentedControlProps,
  SegmentedControlStylesNames,
} from './segmented-control';
export type { SegmentedControlStylesParams } from './segmented-control.styles';
